import React from "react";
import Headline from "~assets/js/components/Typography/Headline";
import i18next from "i18next";
import { Check } from "react-feather";
import PropTypes from "prop-types";

const STATIC_LOGO_ONLY_URL =
    "/wp-content/plugins/pottsalat/static/images/pott-logo-only.png";

export const AcademyBanner = () => {
    return (
        <div className="franchise-academy-banner__hero">
            <div className="container" style={{ position: "relative" }}>
                <div className="franchise-academy-banner__hero-CTA">
                    <p className="franchise-academy-banner__hero-CTA-logo">
                        <img src={STATIC_LOGO_ONLY_URL} alt="logo" />
                        {i18next.t("franchise.academy.banner.logo")}
                    </p>
                    <p className="franchise-academy-banner__hero-CTA-top-title">
                        {i18next.t("franchise.academy.banner.topTitle")}
                    </p>
                    <Headline
                        size={5}
                        className="franchise-academy-banner__hero-CTA-title"
                    >
                        {i18next.t("franchise.academy.banner.title")}
                    </Headline>
                    <div className="franchise-academy-banner__hero-CTA__points">
                        {reactConfig.franchise_reasons &&
                            reactConfig.franchise_reasons.map((text, i) => (
                                <Point key={`reason-${i}`} text={text} />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const Point = ({ text }) => {
    return (
        <div className="franchise-academy-banner__hero-CTA__point">
            <div className="icon">
                <Check color="white"></Check>
            </div>
            <p className="text">{text}</p>
        </div>
    );
};

Point.propTypes = {
    text: PropTypes.string,
};

export default AcademyBanner;
